import Component from '@bythepixel/component-loader';
import Swiper, {
  Pagination, Navigation, Autoplay, Mousewheel, EffectFade,
} from 'swiper';

Swiper.use([Pagination, Navigation, Autoplay, Mousewheel, EffectFade]);

export default class SwiperSlider extends Component {
  static loaderPriority = 'in-view'
  constructor(sliderEl, swiperOptions) {
    super(sliderEl, swiperOptions);
    this.Swiper = Swiper;
    triggerWindowResize(); // Trigger window resize after timeout to correct visual errors in case that JS loaded before CSS
  }
}

function triggerWindowResize() {
  window.setTimeout(() => window.dispatchEvent(new Event('resize')), 500);
}
